import React, { createContext, useContext, useState, useEffect } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const storedPermissions = localStorage.getItem("rolePermissionList");
  const storedUserType = localStorage.getItem("userType");

  const [rolePermissionList, setRolePermissionList] = useState(
    storedPermissions ? JSON.parse(storedPermissions) : []
  );
  const [userType, setUserType] = useState(storedUserType ?? "");

  useEffect(() => {
    localStorage.setItem("rolePermissionList", JSON.stringify(rolePermissionList));
    localStorage.setItem("userType", userType);
  }, [rolePermissionList, userType]);

  return (
    <GlobalContext.Provider
      value={{
        rolePermissionList,
        setRolePermissionList,
        userType,
        setUserType,
        isCollapsed,
        setIsCollapsed,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal() must be used within a GlobalProvider");
  }
  return context;
};
